"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodWithId = void 0;
const period_1 = require("./period");
/**
 * ID付きのPeriod
 * 仲介調整の日時選択など、IDでPeriodを識別する必要がある場合に使用する。
 */
class PeriodWithId extends period_1.Period {
    constructor(start, end, id) {
        super(start, end);
        this.start = start;
        this.end = end;
        this.id = id;
    }
}
exports.PeriodWithId = PeriodWithId;
//# sourceMappingURL=periodWithId.js.map